import "./Lookbook.css";

const Lookbook = ({ onProductClick }) => {
  // Fallback images if no featured products
  const lookbookImages = [
    {
      id: 1,
      image: "/images/lookbook/WhatsApp Image 2026-02-08 at 5.00.17 AM.jpeg",
      alt: "Kids Fashion Lookbook 1",
    },
    {
      id: 2,
      image: "/images/lookbook/WhatsApp Image 2026-02-08 at 5.00.18 AM.jpeg",
      alt: "Kids Fashion Lookbook 2",
    },
    {
      id: 3,
      image: "/images/lookbook/WhatsApp Image 2026-02-08 at 5.00.18 AM (1).jpeg",
      alt: "Kids Fashion Lookbook 3",
    },
    {
      id: 4,
      image: "/images/lookbook/WhatsApp Image 2026-02-08 at 5.01.32 AM.jpeg",
      alt: "Kids Fashion Lookbook 4",
    },
    {
      id: 5,
      image: "/images/lookbook/WhatsApp Image 2026-02-08 at 5.01.32 AM (1).jpeg",
      alt: "Kids Fashion Lookbook 5",
    },
    {
      id: 6,
      image: "/images/lookbook/WhatsApp Image 2026-02-08 at 5.01.33 AM.jpeg",
      alt: "Kids Fashion Lookbook 6",
    },
  ];

  // Always use local lookbook images
  const displayItems = lookbookImages;

  const handleShopClick = (item) => {
    if (item.product && onProductClick) {
      onProductClick({ ...item.product, images: item.product.image || item.product.images });
    }
  };

  return (
    <section className="lookbook-section">
      <div className="lookbook-container">
        <h2 className="lookbook-title">OUR LOOKBOOK</h2>
        <div className="lookbook-grid">
          {displayItems.map((item) => (
            <div key={item.id} className="lookbook-item">
              <img
                src={item.image}
                alt={item.alt}
                onError={(e) => {
                  e.target.src =
                    "https://via.placeholder.com/600x800?text=No+Image";
                }}
              />
              <div className="lookbook-overlay">
                <button
                  className="lookbook-shop-btn"
                  onClick={() => handleShopClick(item)}
                >
                  Shop This Look
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Lookbook;
